// Logging utility with environment variable control
const isDebugEnabled = process.env.REACT_APP_ENABLE_DEBUG_LOGS === 'true';

class Logger {
  constructor(component) {
    this.component = component;
  }

  log(message, ...args) {
    if (isDebugEnabled) {
      console.log(`[${this.component}] ${message}`, ...args);
    }
  }

  error(message, ...args) {
    // Always log errors regardless of debug setting
    console.error(`[${this.component}] ${message}`, ...args);
  }

  warn(message, ...args) {
    // Always log warnings regardless of debug setting
    console.warn(`[${this.component}] ${message}`, ...args);
  }

  info(message, ...args) {
    if (isDebugEnabled) {
      console.info(`[${this.component}] ${message}`, ...args);
    }
  }

  debug(message, ...args) {
    if (isDebugEnabled) {
      console.debug(`[${this.component}] ${message}`, ...args);
    }
  }
}

// Create logger instances for different components
export const authLogger = new Logger('AuthContext');
export const axiosLogger = new Logger('Axios');
export const sessionLogger = new Logger('SessionTest');
export const privateRouteLogger = new Logger('PrivateRoute');

// Export the Logger class for custom loggers
export default Logger; 